// extracted by mini-css-extract-plugin
export default {"container":"ZM-z","topReviewHeading":"_M-z","criticalReview":"aN-z","favorableReview":"bN-z","vsSeparator":"cN-z"};